import { Replace } from "@commonlibs";
import type { RoleDto } from "common/models/api/models/RoleDto";

export type RoleType = RoleDto["roleType"];

export const RoleTypes: Record<Uppercase<Replace<RoleType, "-", "_">>, RoleType> = {
    ORGANIZATION_OWNER: "organization-owner",
    OPERATION_MANAGER: "operation-manager",
    CUSTOMER_SERVICE: "customer-service",
    PROGRAM_MANAGER: "program-manager",
    PARTNER: "partner",
};
